export default "__VITE_ASSET__HQDG2Dfh__"